var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "205769f4d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4a2655f178"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 0 C 6.984375 0 0.484375 6.5 0.484375 14.515625 C 0.484375 22.53125 6.984375 29.03125 15 29.03125 C 23.015625 29.03125 29.515625 22.53125 29.515625 14.515625 C 29.515625 6.5 23.015625 0 15 0 Z M 15 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#205769f4d8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a2655f178)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.725806, 0, 0, 0.725806, 0.48387, 0.00000193548)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 20.000001 -0.00000266667 C 8.956251 -0.00000266667 0.000695111 8.955553 0.000695111 19.999303 C 0.000695111 31.043053 8.956251 39.998609 20.000001 39.998609 C 31.043751 39.998609 39.999307 31.043053 39.999307 19.999303 C 39.999307 8.955553 31.043751 -0.00000266667 20.000001 -0.00000266667 Z M 20.000001 -0.00000266667 ",
    stroke: "#000000",
    strokeWidth: 8,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWhite);
export default __webpack_public_path__ + "static/media/circle-white.2f9a91b3573ae63217e975ca9ddb2f04.svg";
export { ForwardRef as ReactComponent };